export enum NotificationTypeEnum {
  InApp = "InApp",
  Phone = "Phone",
  Email = "Email",
}

export enum NotificationPriorityEnum {
  Alert = "Alert",
  Notice = "Notice",
  Reminder = "Reminder",
}

export const notificationPriorities: NotificationPriorityEnum[] = [
  NotificationPriorityEnum.Alert,
  NotificationPriorityEnum.Notice,
  NotificationPriorityEnum.Reminder, // not implemented but was requested by Amir
];
export enum NotificationChannelsEnum {
  SMS = "SMS",
  PUSH = "PUSH",
  EMAIL = "EMAIL",
}
export const NOTIFICATION_GENERAL_CHANNEL = "GENERAL";
export type NotificationContentType =
  typeof NOTIFICATION_GENERAL_CHANNEL | NotificationChannelsEnum;
export const NOTIFICATION_CONTENT_SET = new Set<NotificationContentType>([
  NOTIFICATION_GENERAL_CHANNEL,
  NotificationChannelsEnum.SMS,
  NotificationChannelsEnum.PUSH,
  NotificationChannelsEnum.EMAIL,
]);

export enum NotificationStateEnum {
  New = "New",
  Resolved = "Resolved",
}
